<template>
  <header :class="['site-header-wrapper', {'hide-logo': hideLogo}]">
    <div class="site-header">
      <NuxtLinkLocale
          to="/"
          class="site-header__logo"
          :class="{'desktop-more-430-only': hideLogo}"
      >

        <span v-if="$siteConfig.brand == 'BookDirect'" class="text-title-1 fw-bold">
          BOOK<span class="color-blue">DIRECT</span><span class="color-light-grey-border">.COM</span>
        </span>

        <span class="text-title-1 fw-bold other-logos" :class="{'other-logos--solaire': $siteConfig.brand === 'Solaire'}" v-else>
          <img
            :src="$siteConfig.logo"
            :width="$siteConfig.brand === 'Solaire' ? 126 : 36"
            :height="$siteConfig.brand === 'Solaire' ? 63 : 24"
            :style="$siteConfig.brand === 'Solaire' ? 'width:auto;height:clamp(44px,8vw,63px);object-fit:contain;display:block;padding:0;margin:0' : ''"
            :alt="$siteConfig.brand"
          >
          <span v-if="$siteConfig.brand !== 'Solaire'">{{$siteConfig.brand}}</span>
        </span>
      </NuxtLinkLocale>
      <div class="site-header__menu">
        <ListYourProperty v-if="$siteConfig.brand == 'BookDirect'"/>
        <CurrencySelector/>
        <LanguageSelector/>
        <button
          v-if="$siteConfig.brand !== 'Solaire'"
          class="theme-toggle"
          :title="`Theme: ${preference}`"
          @click="toggle"
          aria-label="Toggle dark mode"
        >
          <!-- sun -->
          <svg v-if="theme === 'dark'" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
          <!-- moon -->
          <svg v-else width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
        </button>
        <SiteHeaderMenu v-if="!authLayout"/>
      </div>
      <SiteHeaderMobileMenu class="mobile-less-430-only"/>
    </div>
  </header>
</template>

<script setup lang="ts">
import ListYourProperty from "~/components/Checkout/ListYourProperty.vue";
import { useTheme } from "~/composables/useTheme";

const { $siteConfig } = useNuxtApp()
import { useAccountStore } from "~/store/account";
const accountStore = useAccountStore();
const authCookie = useCookie('auth')
const account = computed(() => accountStore.account);
const { theme, preference, toggle } = useTheme()
const props = defineProps({
  hideLogo: {
    type: Boolean,
    default: false
  },
  authLayout: {
    type: Boolean,
    default: false
  }
})

onMounted(() => {
  if (!account.value && authCookie.value?.access_token) {
    accountStore.fetchUser().catch(() => {
      // 401 is expected for unauthenticated users
    })
  }
})
</script>


<style lang="scss" scoped>
.site-header-wrapper {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid var(--grey-border);

  &.hide-logo {
    border-bottom: none;
  }
  padding: 0 var(--page-horizontal-padding);
}
.site-header {
  display: flex;
  height: 72px;
  width: 100%;
  max-width: var(--content-max-width);
  align-items: center;
  justify-content: space-between;
  column-gap: 24px;
  box-sizing: border-box;

  @media screen and (max-width: 1024px) {
    height: 66px;
  }

  @media screen and (max-width: 768px) {
    height: 60px;
    column-gap: 16px;
  }

  @media screen and (max-width: 480px) {
    height: 56px;
  }

  &__logo {
    .text-title-1 {

      //tablet and mobile
      @media screen and (max-width: 1024px){
        font-size: 20px;
      }

      //tablet
      @media screen and (max-width: 1024px) and (min-width: 768px){
        line-height: 1;
      }

      //@media screen and (min-width: 430px) {
      //  display: none;
      //}
    }

    .other-logos {
      display: flex;
      gap: 8px;
    }
  }

  .site-header__menu {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    align-items: center;
    column-gap: 20px;
    row-gap: 12px;
    flex-wrap: wrap;

    @media screen and (max-width: 1024px) {
      column-gap: 16px;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }
  }
}

.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 1px solid var(--grey-border);
  background: transparent;
  color: var(--dark-grey);
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    background: var(--light-grey);
    color: var(--black);
  }
}

.mobile-less-430-only {
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
  }
}

.desktop-more-430-only {
  display: block;

  @media screen and (min-width: 430px) {
    display: none;
  }
}

</style>
